import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import styles from './FeatureBadge.module.scss';

export type FeatureType = 'beta' | 'early-access' | 'experimental' | 'new';
export type BadgeVariant = 'badge' | 'text';

export interface FeatureBadgeProps {
  featureType?: FeatureType;
  text?: string;
  customClass?: string;
  size?: 'small' | 'medium' | 'large';
  variant?: BadgeVariant;
  sx?: SxProps<Theme>;
}

const getDefaultText = (featureType: FeatureType): string => {
  switch (featureType) {
    case 'beta':
      return 'Beta';
    case 'early-access':
      return 'Early Access';
    case 'experimental':
      return 'Experimental';
    case 'new':
      return 'New';
    default:
      return 'Beta';
  }
};

export const FeatureBadge: React.FC<FeatureBadgeProps> = ({
  featureType = 'beta',
  text,
  customClass = '',
  size = 'medium',
  variant = 'badge',
  sx = {},
}) => {
  const displayText = text || getDefaultText(featureType);

  return (
    <Box
      className={`${styles.featureBadge} ${styles[featureType]} ${styles[size]} ${styles[variant]} ${customClass}`}
      sx={sx}
      data-testid={`feature-badge-${featureType}-${variant}`}
    >
      {displayText}
    </Box>
  );
};

export default FeatureBadge;
